const sizes = {
	size_1_1: 1 / 1,
	size_1_2: 1 / 2,
	size_2_1: 2 / 1,
	size_3_4: 3 / 4,
	size_4_3: 4 / 3,
	size_9_16: 9 / 16,
	size_16_9: 16 / 9,
} as const;

type SizeKey = keyof typeof sizes;

export function getSizeClassFromWH(width: number, height: number): SizeKey {
	let minDelta = Infinity;
	let closestSize: SizeKey = 'size_1_1';

	for (const size in sizes) {
		const delta = Math.abs(sizes[size as SizeKey] - width / height);
		if (delta < minDelta) {
			minDelta = delta;
			closestSize = size as SizeKey;
		}
	}

	return closestSize;
}
